<template>
  <div>
    <!-- 订单退款 -->
    <el-dialog
      title="订单退款"
      width="650px"
      center
      custom-class="orderRefund-dia"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="orderRefundDia"
      :before-close="close"
    >
      <div class="content">
        <div>
          您确定将本订单
          <span style="color: #fc8740">{{
            // (
            //   Number(refund_data.pay_money) + Number(refund_data.gift_money)
            // ).toFixed(2)
            refund_data.order_money
          }}</span
          >元退款吗？请填写退款备注。此过程不可逆，须谨慎操作。
        </div>
        <div class="status">
          退款时订单状态：
          <span v-if="refund_data.prescription_status == 2">待审方</span>
          <span v-if="refund_data.prescription_status == 3">已通过</span>
          <span v-if="refund_data.prescription_status == 4">已抓药</span>
          <span v-if="refund_data.prescription_status == 5">已失效</span>
        </div>
        <div class="status" v-if="refund_data.abnormal_type">
          订单异常原因：
          <span v-if="refund_data.abnormal_type == 1">平台异常</span>
          <span v-if="refund_data.abnormal_type == 2"
            >审方拒绝待处理({{ refund_data.reject_desc }})</span
          >
          <span v-if="refund_data.abnormal_type == 3">用户退款待处理</span>
        </div>
        <div class="align-center" style="margin: 10px 0 20px">
          <span class="searchtitle">退款原因</span>
          <el-select
            v-model="abnormalReason"
            placeholder="请选择"
            size="medium"
            style="margin-left: 10px; width: 300px"
            disabled
          >
            <el-option
              v-for="item in reasonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div class="align-center" style="margin: 10px 0 20px">
          <span class="searchtitle">退款原因类型</span>
          <el-select
            v-model="reasonType"
            placeholder="请选择"
            size="medium"
            style="margin-left: 10px; width: 300px"
          >
            <el-option
              v-for="item in reasonTypeOptions"
              :key="item.value"
              :label="item.reason"
              :value="item.reason"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="is_show">
          <div class="align-center" style="margin: 10px 0 5px">
            <span class="searchtitle">验证码</span>
            <el-input
              v-model="authCode"
              size="medium"
              style="margin-left: 10px; width: 200px"
              placeholder="请输入"
            ></el-input>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getCode(2)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('800') : false
              "
              >{{ codeText }}</el-button
            >
          </div>
          <div style="padding-left: 70px; color: #ff9000">
            验证码有效时间3分钟
          </div>
        </div>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请填写退款备注"
          v-model="remark"
          style="margin-top: 20px"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="isRefundOrder" @click="refundOrder"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import common from "@/api/common.js";
import order from "@/api/order";
export default {
  props: {
    orderRefundDia: {
      type: Boolean,
      require: true,
    },
    refund_data: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      refundReason: "退全额",
      abnormalReason: "退全额",
      reasonOptions: [
        {
          label: "退药费",
          value: 0,
        },
        {
          label: "退运费",
          value: 1,
        },
        {
          label: "退全额",
          value: 2,
        },
        {
          label: "退加工费",
          value: 3,
        },
      ],
      reasonType: "",
      reasonTypeOptions: [],
      authCode: "",
      codeText: "获取验证码",
      timer: null,
      isRefundOrder: false,
      // price: undefined,
      remark: "",
      is_show: 0,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  watch: {
    orderRefundDia: {
      handler: function (n) {
        if (n) {
          this.isShowFn();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    getVisitLabel() {
      return new Promise((resolve) => {
        common.getVisitLabel({ label_name: "REASON_TYPE" }).then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.reasonTypeOptions = data;
            resolve(data);
          }
        });
      });
    },
    //是否显示验证码
    isShowFn(row) {
      this.axios
        .post("platform/order/getRefundConfigInfo", {
          order_id: this.refund_data.order_id,
          path: 1,
        })
        .then((res) => {
          if (res.code == 0) {
            this.is_show = res.data.is_show;
          }
        });
      this.getVisitLabel().then((res) => {
        this.authCode = "";
        this.remark = "";
        this.reasonType = "";
      });
    },
    //异常订单退款
    refundOrder() {
      if (!this.reasonType) {
        this.$message.error("请选择退款原因类型");
        return false;
      }
      if (this.refund_data.abnormal_type == 1) {
        if (!this.remark) {
          this.$message.error("请填写退款备注");
          return false;
        }
      }
      if (this.is_show) {
        if (!this.authCode) {
          this.$message.error("请填写验证码");
          return;
        }
      }
      this.isRefundOrder = true;
      let data = {
        id: this.$route.query.id,
        order_id: this.refund_data.order_id,
        remark: this.remark,
        code: this.authCode,
        reason: this.reasonType,
      };
      common
        .saveOrderServiceRefund(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("退款成功");
            this.isRefundOrder = false;
            this.remark = "";
            this.authCode = "";
            this.reasonType = "";
            this.close();
            this.$emit("comfirmOrderRefund", false);
            this.restCode();
          }
        })
        .catch((err) => {
          this.isRefundOrder = false;
        });
    },
    close() {
      this.$emit("update:orderRefundDia", false);
    },
    // 获取验证码
    getCode: _.throttle(
      function () {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        let params = {};
        if (this.remark == "") {
          this.$message.warning("请填写完内容");
          return;
        }
        let m =
          (Number(this.refund_data.pay_money) * 100) / 100 +
          (Number(this.refund_data.gift_money) * 100) / 100;
        if (m <= 0) {
          this.$message.warning("金额要大于0");
          return;
        }
        params = {
          order_id: this.refund_data.order_id,
          price: m,
          refund_desc: this.refundReason,
        };
        order.refundVerifiCode(params).then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("发送成功");
            let time = 60;
            this.timer = window.setInterval(() => {
              if (!time) {
                this.restCode();
                return;
              }
              time -= 1;
              this.codeText = `${time}S`;
            }, 1000);
            this.$once("hook:beforeDestroy", function () {
              this.restCode();
            });
          }
        });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
  },
};
</script>

<style lang="scss">
.orderRefund-dia {
  .content {
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
    .status {
      color: #669961;
      margin: 20px 0;
    }
  }
  .searchtitle {
    display: inline-block;
    width: 100px;
    text-align: right;
    box-sizing: border-box;
  }
}
</style>
